import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useSuppliersAccess = () => {
  const user = useAuthenticatedUser();
  const isResolved = !user.isLoading && user.isAuthenticated;
  const hasSuppliers = isResolved && user.organization.features.includes("suppliers");

  const hasSpendCentre = hasSuppliers && user.organization.features.includes("spend_centre");

  return {
    isResolved,
    hasSuppliers,
    hasSpendCentre,
    hasRenewalCentre: hasSuppliers && user.organization.features.includes("renewal_centre"),
    // Mirrors build_permissions_for_user: these roles carry the spend_centre_admin permission the API checks.
    isSpendCentreAdmin:
      hasSpendCentre && user.pfRoles.some(role => role === "organization_admin" || role === "superadmin"),
  };
};
